<template>
  <v-container fluid class="savitarna-left-menu">
    <div v-html="content" />
    <template v-if="showSideInfo">
      <div id="content-in">
        <div class="left">
          <div class="side-info-box">
            <div v-html="sideInfo" />
          </div>
        </div>
      </div>
    </template>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import headerData from './headerData'
import request from '@/utils/savitarnaMenu'

export default {
  name: 'SavLeftMenu',
  mixins: [headerData],
  data() {
    return {
      content: null,
    }
  },
  computed: {
    ...mapGetters(['infoTooltips','menuState']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    showSideInfo() {
      return this.sideInfo
    },
    tooltipKey() {
      return this.$route.meta.menuTooltip ?? null
    },
    tooltipItem() {
      return (
        this.infoTooltips.find(
          (item) => item.too_kodas === this.tooltipKey && item.too_aktyvus
        ) ?? {}
      )
    },
    sideInfo() {
      return this.tooltipItem.too_tekstas ?? null
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.isLocal && this.$route.query.xid) {
        const xid = this.$route.query.xid
        request({
          url: `menu.do;jsessionid=${xid}`,
          method: 'get',
        }).then((res) => {
          this.content = this.parseLeftMenu(res.data)
          this.$emit('loaded')
        })
      } else if (this.isLocal) {
        if (this.isLocal) { 
          this.content = this.parseLeftMenu(this.menuData)
          this.$emit('loaded')
        }
      } else if (!this.$route.query.xid) {
        this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
      }
    },
    parseLeftMenu(data) {
      data = data.replace(/^.*?(?=<div id="content-in">)/s, '')
      data = data.replace(/(?=<div class="content-info">).*?$/s, '')
      // if(!this.userAdult){
      //   data = this.isAdult(data)
      // }
      return data
    },
    // isAdult(data){
    //   var parser = new DOMParser();
    //   var htmlDom = parser.parseFromString(data, 'text/html');
    //   const list = htmlDom.getElementsByTagName("li");
    //   for (var i = 0; i < list.length; i++) {
    //     const element = list[i].getElementsByTagName("a")[0]
    //     let text = element.innerHTML.replace(/\s/g, "");
    //     if(text !== 'Išrašųužsakymas'){
    //         element.remove();
    //     }
    //   }
    //   return htmlDom.body.innerHTML
    // }
  },
}
</script>

<style lang="scss">
.savitarna-left-menu {
  padding: 0;
  margin: 0;
}
div#content-in ul.side-menu li a {
  width: 219px;
}
.side-menu a {
  width: 100% !important;
}
</style>
